import { makeAutoObservable, runInAction } from "mobx";

export default class MCDMMethodStore {
  mcdmMethods = [];

  constructor() {
    makeAutoObservable(this);
  }

  setData = (data) => {
    this.mcdmMethods = [];
    runInAction(() => {
      this.mcdmMethods = data;
    });
  };

  deleteItem = (id) => {
    let newState = this.mcdmMethods.filter((item) => item.id !== id);
    this.mcdmMethods = [];
    this.mcdmMethods = newState;
  };
}
